<template>
  <div id="app">
    <keep-alive :include="keepAlive">
      3 <router-view></router-view>
      <!-- <router-view v-if="$route.meta.keepAlive"></router-view> -->
    </keep-alive>
    <!-- <router-view v-if="!$route.meta.keepAlive"></router-view> -->
  </div>
</template>
<script>
export default {
  name: "App",
  data () {
    return {
      keepAlive: []
    }
  },

  watch: {

    $route (to, from) {
      // 如果是从b到a页面，则不缓存b
      if (to.name == "user-awb-query-list" && from.name == "user-awb-query") {
        //console.log("进来了")
        this.keepAlive = [];
      } else {
        //console.log("进来了缓存")
        this.keepAlive = ['user-awb-query-list'];
      }
      //  if(to.name == "airway-bill-query" && from.name == "login"){
      //    this.keepAlive = [];
      //  }else{
      //    this.keepAlive = ['airway-bill-query'];
      //  }
    },


  }
};
</script>
